import styled, { createGlobalStyle } from "styled-components";
import {
  getApplicationNameTextColor,
  getSecondaryMenuContainerBackgroundColor,
  getSecondMenuItemBackgroundColorOnHover,
  getMenuContainerBackgroundColor,
  getMenuItemBackgroundColorOnHover,
  getMenuItemTextColor,
  getBorderColor,
  getCollpsedHoverBg,
  getCollpsedHoverColor,
} from "pages/AppViewer/utils";
import { Colors } from "constants/Colors";
import { NAVIGATION_SETTINGS } from "constants/AppConstants";
import type { NavigationSetting } from "constants/AppConstants";

export const StyledIconContainer = styled.div<{
  primaryColor: string;
  navColorStyle: NavigationSetting["colorStyle"];
}>`
  color: ${({ navColorStyle, primaryColor }) =>
    getApplicationNameTextColor(primaryColor, navColorStyle)};
`;

export const CollapseIconContainer = styled.div<{
  borderRadius: string;
  primaryColor: string;
  navColorStyle: NavigationSetting["colorStyle"];
  isOpen: boolean;
  isPinned: boolean;
  isInline: boolean | undefined;
}>`
  height: 24px;
  width: 24px;
  transition: all 0.3s ease-in-out;
  border-radius: ${({ borderRadius }) => borderRadius};

  ${StyledIconContainer} {
    color: ${({ navColorStyle, primaryColor }) =>
      getMenuItemTextColor(primaryColor, navColorStyle, true)};
  }
  background: ${({ navColorStyle, primaryColor }) =>
    getBorderColor(primaryColor, navColorStyle)};

  :hover {
    background: ${({ navColorStyle, primaryColor }) =>
      getBorderColor(primaryColor, navColorStyle)};

    ${StyledIconContainer} {
      ${({ navColorStyle, primaryColor }) => {
        return `color: ${getCollpsedHoverColor(primaryColor, navColorStyle)}`;
      }};
    }
  }

  ${({ isInline, isOpen, isPinned, navColorStyle, primaryColor }) => {
    if (!isPinned && !isOpen) {
      return `
        transform: translateX(${isInline ? 0 : 40} px);
        background: ${getMenuContainerBackgroundColor(
          primaryColor,
          navColorStyle,
        )};
        box-shadow: ${
          isInline
            ? "none"
            : "0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06)"
        } ;
        transition: background 0.3s ease-in-out, transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);

        ${StyledIconContainer} {
          color: ${Colors.GRAY_500};
        }

        :hover {
          background: ${getCollpsedHoverBg(primaryColor, navColorStyle)};

          ${StyledIconContainer} {
            color: ${getCollpsedHoverColor(primaryColor, navColorStyle)};
          }
        }
      `;
    }
  }}
`;

export const TooltipStyles = createGlobalStyle`
  .app-sidebar-tooltip {
    transform: translateX(40px);
  }
`;
